import ApplicationController from '../application_controller';

// Connects to data-controller="landing-pages--sticky-header"
export default class extends ApplicationController {
  static targets = ['header'];

  connect() {
    super.connect();
    this.positionY = 0;
  }

  switchInOut(event) {
    const { currentTarget } = event;
    const currentY = currentTarget.scrollTop;

    if (this.positionY < currentY && currentY > 60) {
      this.headerTarget.classList.add('disappear');
      this.headerTarget.classList.remove('appear');
    } else {
      this.headerTarget.classList.remove('disappear');
      this.headerTarget.classList.add('appear');
    }

    this.positionY = currentY;
  }
}
